import React, { useRef, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";
import { Button } from "./ui/button";
import { DialogFooter } from "./ui/dialog";
import { LandingPreview, ThemeFields, THEME_DEFAULTS, themePayload } from "./TenantWizard";

const img = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

// Modifica tema di un circuito esistente (Super-Admin): stessi campi e anteprima del wizard + upload logo da dispositivo
export default function TenantThemeDialog({ tenant, onSave, busy }) {
  const th = tenant.theme || {};
  const [f, setF] = useState({ ...THEME_DEFAULTS, ...Object.fromEntries(Object.entries(th).filter(([, v]) => v != null)), name: tenant.name });
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);
  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    const fd = new FormData(); fd.append("file", file);
    try { const { data } = await api.post(`/platform/tenants/${tenant.id}/logo`, fd, { headers: { "Content-Type": "multipart/form-data" } }); setF((p) => ({ ...p, logo_url: data.url })); toast.success("Logo caricato: salva il tema per applicarlo"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setUploading(false); if (fileRef.current) fileRef.current.value = ""; }
  };
  const pf = { ...f, logo_url: img(f.logo_url) };
  return (
    <div className="space-y-4" data-testid="tenant-theme-dialog">
      <div className="grid gap-4 md:grid-cols-[1fr_280px]">
        <div className="space-y-3 min-w-0">
          <ThemeFields f={f} setF={setF} />
          <div className="flex items-center gap-3 rounded-xl border border-zinc-800 p-3" data-testid="tenant-logo-upload-box">
            {f.logo_url ? <img src={img(f.logo_url)} alt="" className="h-10 w-10 object-contain rounded bg-white p-0.5" data-testid="tenant-logo-preview" /> : <div className="h-10 w-10 rounded bg-zinc-800" />}
            <div className="flex-1 text-xs text-zinc-400">Logo del circuito: caricalo dal telefono o dal computer (jpg/png/webp/svg, max 3 MB).</div>
            <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="tenant-logo-file" />
            <Button type="button" variant="outline" size="sm" disabled={uploading} onClick={() => fileRef.current?.click()} className="border-zinc-700" data-testid="tenant-logo-upload"><Upload className="h-3.5 w-3.5 mr-1" /> {uploading ? "Carico…" : "Carica logo"}</Button>
            {f.logo_url && <Button type="button" variant="ghost" size="sm" onClick={() => setF((p) => ({ ...p, logo_url: "" }))} data-testid="tenant-logo-remove"><X className="h-3.5 w-3.5" /></Button>}
          </div>
        </div>
        <div className="hidden md:block"><div className="text-[11px] text-zinc-500 mb-2 text-center">Anteprima landing</div><LandingPreview f={pf} /></div>
      </div>
      <p className="text-[11px] text-zinc-500">Il tema viene applicato subito alla Home e al portale clienti del circuito (colori, carattere, stile card, logo, slogan).</p>
      <DialogFooter><Button type="button" disabled={busy || uploading} onClick={() => onSave(themePayload(f))} className="bg-[color:var(--paprika)] hover:bg-[color:var(--paprika-hover)]" data-testid="tenant-theme-save">{busy ? "Salvo…" : "Salva tema"}</Button></DialogFooter>
    </div>
  );
}
